// libraries.
import { Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";

// hooks.
import { useNid } from "@pages/HomePage";
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";
import { usePostVimMutation } from "@domains/VIM/services/post-vim.endpoints";
import { useInventoryPricingMutation } from "@store/apiSlices/inventoryPricing/inventoryPricing.endpoints";

// components.
import { DiagnosisCardsMX } from "./CardSummaryInfoMX/DiagnosisCardsMX";
import { PriceInventorySummaryMX } from "./PriceInventorySummaryMX/PriceInventorySummaryMX";
import { inventoryPriceType } from "../type";
import { useSelector } from "react-redux";
import {
  getSelectedOption,
  getSuggestionOption,
  getVIMMetrics,
} from "@domains/VIM/slices/vim.slice";
import { useInventorySubmit } from "../shared/hooks/useInventorySubmit";
import { useHandleSuccess } from "../shared/hooks/useHandleSuccess";

export interface InterfaceFormMX {
  applyPercentageToPrices: boolean;
  commentInput: string;
  commissionPercentage: number;
  isLoading: boolean;
  leader: string;
  minPublicationPrice: number;
  publicationPrice: number;
  utilityCurrent: number | null;
  utilityInitial: number | null;
}

export const InventorySummaryMX = () => {
  const { user } = useUserProfile();
  const paths = useParams();
  const { nid } = useNid();
  const selectedOption = useSelector(getSelectedOption);
  const suggestionOption = useSelector(getSuggestionOption);
  const vimMetrics = useSelector(getVIMMetrics);

  const nidSelected = paths.nid ? paths.nid : nid;

  const [handlePostInventoryPricing, { isSuccess, isError }] =
    useInventoryPricingMutation();

  const [handleVIMLog] = usePostVimMutation();

  const { onSubmit } = useInventorySubmit({
    handlePostInventoryPricing,
    handleVIMLog,
    inventoryPriceType,
    nidSelected: Number(nidSelected),
    selectedOption,
    suggestionOption,
    user,
    vimMetrics,
  });

  const methods = useForm<InterfaceFormMX>({
    defaultValues: {
      applyPercentageToPrices: true,
      commentInput: "",
      commissionPercentage: 0,
      isLoading: false,
      leader: "",
      minPublicationPrice: 0,
      publicationPrice: 0,
      utilityCurrent: null,
      utilityInitial: null,
    },
    mode: "all",
  });

  useHandleSuccess(isSuccess, isError);

  return (
    <>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="d-flex h-100 p-0"
          data-testid="inventory-form-mx"
        >
          <Col
            md={9}
            className=" p-4 price-info  d-flex flex-column gap-4 overflow-y-auto "
            data-testid="inventory-info-mx"
            style={{ height: "calc(100vh - 50px)" }}
          >
            <DiagnosisCardsMX />
          </Col>
          <Col
            md={3}
            className="p-4 price-summary text-white overflow-y-auto"
            data-testid="inventory-summary-mx"
            style={{ height: "calc(100vh - 50px)" }}
          >
            <PriceInventorySummaryMX />
          </Col>
        </form>
      </FormProvider>
    </>
  );
};
